/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommMobileStreamBannerData } from './ecomm-mobile-stream-banner.data';
import { IEcommMobileStreamBannerProps } from './ecomm-mobile-stream-banner.props.autogenerated';

export interface IEcommMobileStreamBannerViewProps extends IEcommMobileStreamBannerProps<IEcommMobileStreamBannerData> {}

/**
 *
 * EcommMobileStreamBanner component
 * @extends {React.PureComponent<IEcommMobileStreamBannerProps<IEcommMobileStreamBannerData>>}
 */
class EcommMobileStreamBanner extends React.PureComponent<IEcommMobileStreamBannerProps<IEcommMobileStreamBannerData>> {
  public render(): JSX.Element | null {
    return this.props.renderView(this.props);
  }
}

export default EcommMobileStreamBanner;